





















import {
  ref,
  defineComponent,
  useContext,
} from "@nuxtjs/composition-api";
import { SfModal } from "@storefront-ui/vue";
import { useUiState } from "~/composables/useUiState";
import { useCart } from "~/modules/checkout/composables/useCart";
import { useWishlist } from "~/modules/wishlist/composables/useWishlist";
import { useUser } from "~/modules/customer/composables/useUser";

import LoginForm from "./forms/LoginForm.vue";
import { LoginFormFields, FormName } from "./forms/types";

export default defineComponent({
  name: "LoginModal",
  components: {
    SfModal,
    LoginForm,
  },
  setup(_, { emit }) {
    const { isLoginModalOpen } = useUiState();

    const { login, loading, error: userError } = useUser();

    const { load: loadCart } = useCart();
    const { loadItemsCount } = useWishlist();

    const currentlyDisplayedForm = ref<FormName>("login");

    const loginForm = ref<LoginFormFields>({
      email: "",
      password: "",
    });

    // @ts-expect-error Recaptcha is not registered as a Nuxt module. Its absence is handled in the code
    const { $recaptcha, $config } = useContext();
    const isRecaptchaEnabled = ref<boolean>(
      typeof $recaptcha !== "undefined" && Boolean($config.isRecaptcha)
    );

    const getRecaptchaInfo = async (
      isRecaptchaOn: boolean
    ): Promise<{ token: string | null; cleanup: () => void }> => {
      if (isRecaptchaOn) {
        $recaptcha.init();
        return {
          token: await $recaptcha.getResponse(),
          cleanup: () => {
            $recaptcha.reset();
          },
        };
      }
      return { token: null, cleanup: () => {} };
    };

    const onLoginFormSubmit = async (form: LoginFormFields) => {
      loginForm.value = form;
      const { token, cleanup } = await getRecaptchaInfo(
        isRecaptchaEnabled.value
      );
      await login({
        user: { ...form, ...(token ? { recaptchaToken: token } : {}) },
      });
      cleanup();
      if (!userError.value.login) {
        emit("close");
        await Promise.all([loadItemsCount(), loadCart()]);
      }
    };

    return {
      isLoginModalOpen,
      userError,
      loading,
      currentlyDisplayedForm,
      loginForm,
      isRecaptchaEnabled,
      onLoginFormSubmit,
    };
  },
});
